export const detectExperienceIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete experience" || cleaned === "remove experience") {
        return { intent: "delete_experience" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) experience/);
    if (deleteMatch) {
        return { intent: "delete_experience", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create experience") || cleaned.includes("add experience")) {
        return { intent: "create_experience" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create experience named (.+)/);
    if (createMatch) {
        return { intent: "create_experience", name: createMatch[1].trim() };
    }

    return null;
};
